import { boxApply1qmzdb3dh90hg as boxApply } from '../js/coreRuntime.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function tryToComputeNext($this) {
  $this.li_1 = 3;
  $this.ni();
  return $this.li_1 === 1;
}
var AbstractIteratorClass;
function AbstractIterator() {
  if (AbstractIteratorClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
        this.li_1 = 0;
        this.mi_1 = null;
      }
      q1() {
        var tmp;
        switch (this.li_1) {
          case 2:
            tmp = false;
            break;
          case 1:
            tmp = true;
            break;
          case 0:
            tmp = tryToComputeNext(this);
            break;
          default:
            throw IllegalArgumentException().n2('hasNext called when the iterator is in the FAILED state.');
        }
        return tmp;
      }
      r1() {
        if (this.li_1 === 1) {
          this.li_1 = 0;
          return this.mi_1;
        }
        if (this.li_1 === 2 || !tryToComputeNext(this)) {
          throw NoSuchElementException().t6();
        }
        this.li_1 = 0;
        return this.mi_1;
      }
      oi(value) {
        this.mi_1 = value;
        this.li_1 = 1;
      }
      pi() {
        this.li_1 = 2;
      }
    }
    initMetadataForClass($, 'AbstractIterator');
    AbstractIteratorClass = $;
  }
  return AbstractIteratorClass;
}
//region block: exports
export {
  AbstractIterator as AbstractIterator1svf7vpi1lw8y,
};
//endregion

//# sourceMappingURL=AbstractIterator.mjs.map
